<template>
    <div>
        <div class="flex flex-wrap">
            <FooterLink link="error-page">Help</FooterLink>
            <FooterLink link="error-page">Insurance</FooterLink>
            <FooterLink link="error-page">Reviews</FooterLink>
            <FooterLink link="error-page">Terms of Use</FooterLink>
            <FooterLink link="error-page">Privacy Policy</FooterLink>
        </div>

        <div class="legal pv3 mid-gray">2017 Tooliaba Inc. All rights Reserved.</div>
    </div>
</template>

<script>
import FooterLink from '@/components/footer/links/FooterLink.vue';

export default {
    components: {
        FooterLink
    }
};
</script>
